import { useContext } from 'react';

import { RouteContext } from 'src/context';
import { useIsStudioWorkspace } from 'src/hooks/useIsStudioWorkspace';
import { useAppSelector } from 'src/hooks/useStore';
import {
  getFirstAccessibleNavItemRedirectPath,
  isInternalHomePath,
  useFirstAccessibleNavItem,
} from 'src/legacy/components/Sidebar/useFirstAccessibleNavItem';
import { useSidebarItems } from 'src/legacy/components/Sidebar/useSidebarItems';

/**
 * Studio workspaces have no Dashboard. On home paths (`/` and `/portal/*`), show a
 * loading state while SidebarNav redirects to the first accessible sidebar item.
 * Classic workspaces still render HomePageContent on those paths.
 */
export function useStudioRootRedirect() {
  const isStudioWorkspace = useIsStudioWorkspace();
  const { pathname } = useContext(RouteContext);
  const isClient = useAppSelector((state) => state.user.isClient);
  const { sections: mainSidebarSections, isLoadingInstalls } =
    useSidebarItems('main');
  const firstAccessibleNavItem = useFirstAccessibleNavItem(
    mainSidebarSections,
    isClient,
  );

  const isHomePath = isInternalHomePath(pathname);
  const shouldUseStudioRedirect = isStudioWorkspace && !isClient && isHomePath;
  const redirectPath = firstAccessibleNavItem
    ? getFirstAccessibleNavItemRedirectPath(firstAccessibleNavItem)
    : undefined;

  const isRedirecting =
    shouldUseStudioRedirect &&
    (isLoadingInstalls || (!!redirectPath && redirectPath !== pathname));

  return {
    shouldShowHomePage: isHomePath && !isClient && !shouldUseStudioRedirect,
    isRedirecting,
  };
}
